import { DialogComponent } from '@theme/dialog';

class SizeGuide extends DialogComponent {
  #opener;

  connectedCallback() {
    super.connectedCallback();
    const navigation = this.querySelector('.plch-size-guide-content__nav');
    const slot = this.querySelector('.plch-size-guide__navigation');
    if (navigation && slot) slot.append(navigation);
    this.addEventListener('click', this.#jumpToTable);
    this.addEventListener('keydown', this.#trapFocus);
    this.refs.dialog.addEventListener('cancel', this.#cancel);
    this.refs.dialog.addEventListener('close', this.#restoreFocus);
  }

  disconnectedCallback() {
    if (this.refs.dialog.open) this.closeDialog();
    this.removeEventListener('click', this.#jumpToTable);
    this.removeEventListener('keydown', this.#trapFocus);
    this.refs.dialog.removeEventListener('cancel', this.#cancel);
    this.refs.dialog.removeEventListener('close', this.#restoreFocus);
    super.disconnectedCallback();
  }

  openGuide(event) {
    event.preventDefault();
    this.#opener = this.querySelector('.plch-size-guide__trigger');
    this.showDialog();
  }

  #jumpToTable = (event) => {
    if (!(event.target instanceof Element)) return;
    const link = event.target.closest('.plch-size-guide-content__nav a[href^="#"]');
    if (!link || !this.contains(link)) return;
    const id = link.getAttribute('href').slice(1);
    const target = this.querySelector(`#${CSS.escape(id)}`);
    if (!target) return;
    event.preventDefault();
    target.scrollIntoView({ block: 'start', behavior: 'instant' });
    target.focus({ preventScroll: true });
  };

  #cancel = (event) => {
    event.preventDefault();
    this.closeDialog();
  };

  #trapFocus = (event) => {
    const { dialog } = this.refs;
    if (event.key !== 'Tab' || !dialog.open) return;
    const controls = [...dialog.querySelectorAll('a[href], button:not([disabled]), [tabindex="0"]')]
      .filter((element) => element.getClientRects().length > 0);
    const first = controls[0];
    const last = controls.at(-1);
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last?.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first?.focus();
    }
  };

  #restoreFocus = () => {
    if (this.#opener?.isConnected) this.#opener.focus({ preventScroll: true });
    this.#opener = null;
  };
}

if (!customElements.get('plch-size-guide')) customElements.define('plch-size-guide', SizeGuide);
